export const HEADER_HEIGHT = 50;